export enum TextTransform {
    NONE = 'NONE',
    CAPITALIZE = 'CAPITALIZE',
    UPPERCASE = 'UPPERCASE',
    LOWERCASE = 'LOWERCASE',
}
